import Link from 'next/link'
import React from 'react'
import { useAppContext } from '../context/siteMapContext'
import { ITag } from '../interfaces/article'

interface ITagsProp {
  tags: ITag[]
}

interface ITagProps {
  name: string
}

export const Tag: React.FC<ITagProps> = ({ name }) => {
  const { highContrastOn } = useAppContext();
  const urlObject = {
    pathname: '/search',
    query: {
      webmenuId: 'SEARCH',
      kifejezes: name,
    },
  }
  return (
    <div className={`h-8.75 rounded p-1 2xl:text-tag-2xl whitespace-nowrap inline-block no-underline ${highContrastOn ? 'bg-white' : 'bg-[#dcdee0]'}`}>
      <Link href={urlObject} as={`/kereses?kifejezes=${encodeURIComponent(name)}`}>
        <a className='w-full h-full flex px-4  !text-black !no-underline'>
          <span className={`m-auto ${highContrastOn ? 'text-black' : ''}`}>#{name}</span>
        </a>
      </Link>
    </div>
  )
}

const TagList: React.FC<ITagsProp> = ({ tags }) => {
  return (
    <div className='xl:w-half-screen flex flex-wrap gap-1 mb-20'>
      {tags.map(({ name }) => (
        <Tag name={name} key={name} />
      ))}
    </div>
  )
}

export default TagList
